export const MODAL_KEYS = {
    RESEND_TRANSACTIONS: 'resendTransactionsModal',
    CANCEL_TERMINATE: 'cancelTerminateModal',
    OVERRIDE_ENROLLMENT_STATUS: 'overrideEnrollmentStatusModal',
    PREMIUM_HISTORY: 'premiumHistoryModal',
    REINSTATE_ENROLLMENT: 'reinstateEnrollmentModal',
    RESULT: 'resultModal',
    TERMINATION: 'terminationModal',
};
